import { ProductInfoApi } from '../types/api/products-info-api';
import { BaseRouteProps } from '../types/route-props';
import {
  SPRYKER_PRODUCT_CARD_SECONDARY_PATH,
  ATG_PRODUCT_CARD_ADDITION_PATH,
} from '../constants';
import { Method, callAxios, AxiosRequestConfig } from '../axios';
import { buildURL, getBrandName, isV3 } from '../common';

export const getProductInfoEndpointUrl = ({
  contextRoot,
  countryCode,
  languageCode,
}: BaseRouteProps): string => {
  if (isV3()) return SPRYKER_PRODUCT_CARD_SECONDARY_PATH;

  return buildURL({
    host: '',
    contextRoot,
    countryCode,
    languageCode,
    endpoint: ATG_PRODUCT_CARD_ADDITION_PATH,
  });
};

export const productsInfoApiFetchers = {
  getProductsInfoFetcher: async ({
    contextRoot,
    countryCode,
    languageCode,
    params,
  }: BaseRouteProps & {
    params: ProductInfoApi.GetProductsInfoParams;
  }) => {
    const GET_PRODUCTS_INFO_URL = getProductInfoEndpointUrl({
      contextRoot,
      countryCode,
      languageCode,
    });
    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: GET_PRODUCTS_INFO_URL,
    };

    if (isV3()) {
      requestSettings.params = {
        'country-code': countryCode,
        'language-code': languageCode,
        brand: getBrandName(),
        ...params,
      };
    } else {
      requestSettings.params = params;
    }

    const response = await callAxios<{
      response: ProductInfoApi.GetProductsInfoResponse;
    }>(requestSettings);

    return response.data;
  },
};
